import { TaskAttributeTreeItem } from "../users/UserProfile";
import { AbstractAttributeList } from "./AbstractAttributeList";
import { JobAttribute } from "./JobAttribute";

export class JobAttributeList extends AbstractAttributeList {

  taskAttributesTree: TaskAttributeTreeItem[] = [];

  constructor(options: any) {
    super(options);

    options.data.forEach((attr: any, index: any) =>
      this.attributes.push(new JobAttribute(index, attr))
    );
    this.initAttributesLists();
  }

  initAttributesLists() {
    this.attributes.forEach((a) => {
      if (a.isParent) {
        a.childAttributes.forEach((c: any) => {
          const attrDef = this.getByDefinition(c.attributeDefinitionId);
          if (attrDef) {
            c.required = attrDef.required;
            c.mandatory = attrDef.mandatory;
            c.categories = attrDef.categories;
            c.currentProficiency = attrDef.currentProficiency;
            c.requiredProficiency = attrDef.requiredProficiency;
            c.type = attrDef.type;
          }
        });
      }
    });

    super.initAttributesLists();
  }

  getByDefinition(defId: any) {
    return this.attributes.find((a) => a.attributeDefinitionId === defId);
  }
}
